import React, { useState } from "react";
import "./CodeEditor.css";

const defaultHtml = `<h1 style="color: #4a2d70">Hello, World!</h1>
<p>Write your HTML here. You can include inline CSS &amp; JS too.</p>`;

export default function CodeEditor() {
  const [code, setCode] = useState(defaultHtml);
  const [output, setOutput] = useState(defaultHtml);

  const handleRun = () => {
    setOutput(code);
  };

  const handleClear = () => {
    setCode("");
    setOutput("");
  };

  return (
    <div className="ce-container">
      <div className="ce-header">
        <h2 className="ce-title">Simple HTML Editor</h2>
        <div className="ce-controls">
          <button className="ce-btn" onClick={handleRun}>Run</button>
          <button className="ce-btn ce-btn-secondary" onClick={handleClear}>Clear</button>
        </div>
      </div>

      <div className="ce-body">
        <div className="ce-pane ce-editor-pane">
          <div className="ce-pane-title">Editor</div>
          <textarea
            className="ce-textarea"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Type HTML/CSS/JS here..."
          />
        </div>

        <div className="ce-pane ce-preview-pane">
          <div className="ce-pane-title">Preview</div>
          <iframe
            title="preview"
            srcDoc={output}
            className="ce-iframe"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        </div>
      </div>
    </div>
  );
}
